import * as T from './types'

export default {
    [T.SET_COMPONENT_TEMPLATE](state, payload) {
        state.componentTemplateList = payload
    },
    [T.UPDATE_LOADING_STATUS](state, payload) {
        state.loading = payload
    },
}
